import styled from 'styled-components';
import { Button, ButtonGroup } from '@material-ui/core';
import ToggleButton from '@material-ui/lab/ToggleButton';
export const ToggleButtonWrapper = styled.div`
  text-align: right;
  display: flex;
  align-items: center;
`;
export const ButtonWrapper = styled.div`
  float: right;
  border-radius: 5px;
`;
export const IconButton = styled.button`
  padding: 0;
`;
export const ButtonStyleWrapper = styled(Button)`
  && {
    padding: 0 8px;
    min-width: 14px;
    height: 14px;
    color: #1a1a1a;
  }
  &.MuiButton-root:hover {
    color: #4a66f1;
  }

  &.MuiButton-root:focus {
    color: #035099;
  }

  &.MuiButton-label {
    padding: 0;
    width: 14px;
    height: 14px;
  }
`;
export const ApplyStyleWrapper = styled(ToggleButton)`
  &.MuiToggleButton-root {
    margin: 0px 8px 0px 0px !important;
    border-radius: 5px;
    text-transform: none;
    height: 32px !important;
    min-width: 72px !important;
    border-color: #7ba2c5 !important;
    border-radius: 5px !important;
    font-family: 'OpenSans-Regular';
    color: ${props => props.disabled ? 'black !important' : '#ffffff !important'};
    background-color: ${props => props.disabled ? '#c6c7c8 !important' : '#005099 !important'};
    line-height: 14px !important;
    outline: none !important;
    border: 1px solid rgba(0, 0, 0, 0.12);
    padding: 11px;
    font-size: 13px;
    box-sizing: border-box;
  }
  &.MuiToggleButton-root:focus {
    color: #ffffff !important;
    background-color: #005099;
  }
`;
export const CancelStyleWrapper = styled(ToggleButton)`
  &.MuiToggleButton-root {
    margin: 0px 8px 0px 0px !important;
    border-radius: 5px;
    text-transform: none;
    height: 32px !important;
    min-width: 72px !important;
    border-color: #7ba2c5 !important;
    border-radius: 5px !important;
    font-family: 'OpenSans-Regular';
    color: #005099;
    line-height: 14px !important;
    outline: none !important;
    border: 1px solid rgba(0, 0, 0, 0.12);
    padding: 11px;
    font-size: 13px;
    box-sizing: border-box;
  }
  &.MuiToggleButton-root:focus {
    color: #ffffff !important;
    background-color: #005099;
  }
`;
export const ButonGroupStyle = styled(ButtonGroup)`
  display: inline-block;
  padding: 8px 28px 0px;
  text-align: end;
`;
export const ClearAllButton = styled(Button)`
  && {
    font-size: 12px;
    color: #005099;
    font-family: 'OpenSans-SemiBold';
    font-weight: 600;
    text-transform: none;
    height: 30px;
    margin-top: 10px;
    margin-left: 10px;
  }
`;
export const StyledWrapper = styled.div`
  display: flex;
  padding-top: 3px;
`;
export default {
  ToggleButtonWrapper,
  ButtonWrapper,
  IconButton,
  ButtonStyleWrapper,
  ApplyStyleWrapper,
  ButonGroupStyle,
  ClearAllButton,
  StyledWrapper,
  CancelStyleWrapper
};